export const NAME = 'acquiring'
